import {createSelector} from 'reselect'
import selectorsGenerator from '../../administration/userManagement/hierarchyAssignmentsPanelTab/selectorsGenerator'
import {selectUserProfile} from '../selectors'
import {HierarchyLevels} from 'constants'

const getCPTAssignmentsList = state => selectUserProfile(state).cptLists

const hierarchyAssignmentsPanelTabSelectors = selectorsGenerator(getCPTAssignmentsList)

export const getTab = hierarchyAssignmentsPanelTabSelectors.getTab

export const getTaskIds = hierarchyAssignmentsPanelTabSelectors.getTaskIds

export const getProjectIds = hierarchyAssignmentsPanelTabSelectors.getProjectIds

export const getUsersCounters = hierarchyAssignmentsPanelTabSelectors.getUsersCounters

export const selectTaskEntities = hierarchyAssignmentsPanelTabSelectors.selectTaskWaEntities

export const selectProjectEntities = hierarchyAssignmentsPanelTabSelectors.selectProjectWaEntities

export const selectCustomerEntities = hierarchyAssignmentsPanelTabSelectors.selectCustomerMaEntities

export const isLoading = hierarchyAssignmentsPanelTabSelectors.isLoading

export const isNeedToLoadTaskData = createSelector(
    getTab,
    (tab) => (tab === HierarchyLevels.TASK)
)

export const isNeedToLoadProjectData = createSelector(
    getTab,
    (tab) => (tab === HierarchyLevels.PROJECT)
)

export const isNeedToLoadCustomerData = createSelector(
    getTab,
    (tab) => (tab === HierarchyLevels.CUSTOMER)
)

export const getCounters = createSelector(
    getUsersCounters,
    (counters) => ({
        customers: {
            curValue: counters.customers,
            maxValue: counters.customers,
        },
        projects: {
            curValue: counters.projects,
            maxValue: counters.projects,
        },
        tasks: {
            curValue: counters.tasks,
            maxValue: counters.tasks,
        },
    })
)

export const getEntirelyAssignedTasksCounter = createSelector(
    getTaskIds,
    getCounters,
    (ids, counters) => (counters.tasks.curValue - ids.length)
)

export const getEntirelyAssignedProjectCounter = createSelector(
    getProjectIds,
    getCounters,
    (ids, counters) => (counters.projects.curValue - ids.length)
)

export const getAllAssignedCustomerCounter = createSelector(
    getCounters,
    (counters) => (counters.customers.curValue)
)

export const getAllAssignedProjectCounter = createSelector(
    getCounters,
    (counters) => (counters.projects.curValue)
)



// WEBPACK FOOTER //
// ./web/js/userProfile/cptAssignmentsList/selectors.js